// Regras puras do vencimento da licença no login. Mesma régua do
// routes/Route.js: o acesso vale até o fim do dia do vencimento; a empresa 1
// (dona da plataforma) nunca vence.
import moment from "moment";
import { i18n } from "../../translate/i18n";

const DIAS_DE_AVISO = 5;

export const situacaoDoVencimento = (company, hoje = moment()) => {
  if (!company || company.id === 1 || !company.dueDate) {
    return { expirado: false, dias: null, vencimento: null };
  }
  const venc = moment(company.dueDate).startOf("day");
  const dias = venc.diff(moment(hoje).startOf("day"), "days");
  return { expirado: dias < 0, dias, vencimento: venc.format("DD/MM/YYYY") };
};

// Toast do login: erro para licença vencida (a tela de pagamento abre em
// seguida), aviso nos últimos dias, nada com folga.
export const avisoDoLogin = ({ expirado, dias, vencimento }) => {
  if (expirado) {
    return {
      tipo: "error",
      texto: i18n.t("auth.dueDate.expired", { date: vencimento }),
    };
  }
  if (dias === null || dias === undefined || dias >= DIAS_DE_AVISO) return null;
  if (dias === 0) return { tipo: "warn", texto: i18n.t("auth.dueDate.expirationToday") };
  const unidade = i18n.t(dias === 1 ? "auth.dueDate.day" : "auth.dueDate.days");
  return {
    tipo: "warn",
    texto: `${i18n.t("auth.dueDate.expiration")} ${dias} ${unidade}`,
  };
};
